import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import NotificationLayer from "../components/NotificationLayer";



const NotificationPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Settings - Notification" />

        {/* NotificationLayer */}
        <NotificationLayer />


    </>
  );
};

export default NotificationPage; 
